import Select, { GroupBase, OptionsOrGroups } from "react-select";
import { Control, RegisterOptions, useController } from "react-hook-form";
import { StateManagerProps } from "react-select/dist/declarations/src/useStateManager";

export interface ISelectComBusca extends StateManagerProps {
    name: string;

    //value: string | number
    wrapperClassName?: string;
    labelClassName?: string;
    registerOptions?: RegisterOptions;
    label?: string;
    isMulti?: boolean;

    control?: Control;
    defaultValue?: any;
    options:
        | OptionsOrGroups<
              {
                  value: number;
                  label: string;
              },
              GroupBase<{
                  value: number;
                  label: string;
              }>
          >
        | undefined;
}

export default function SelectComBusca(props: ISelectComBusca) {
    const {
        wrapperClassName,
        registerOptions,
        label,
        labelClassName,
        name,
        control,
        defaultValue,
        options,
        ...selectProps
    } = props;

    const { field } = useController({
        name: name ?? "",
        control,
        defaultValue: props.defaultValue ?? [],
    });

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    return (
        <Select
            options={props.options}
            isClearable
            isMulti={props.isMulti ?? false}
            components={{
                DropdownIndicator: () => null,
                IndicatorSeparator: () => null,
            }}
            styles={customStyles}
            placeholder={""}
            noOptionsMessage={() => "Sem opções"}
            {...selectProps}
            {...field}
        />
    );
}
